import { register } from "async-ops";
import { callMvcApi } from "../../../../../call-web-api";
export const GET_REQUESTER_LINKED_DATA = "GET_REQUESTER_LINKED_DATA";

export const service = async (data) => {
  const options: object = {
    url: `/Api/Requester/GetRequesterLinkedData?requesterId=` + data,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_REQUESTER_LINKED_DATA, service, mock);
